<template>
  <div class="cms-container" style="height: calc(100vh - 150px);">
    <div class="cms-sidebar">
      <div class="sidebar-title">组件库</div>
      <draggable class="widget-list" :list="widgetList" :group="{ name: 'widgets', pull: 'clone', put: false }"
        :clone="cloneWidget" :sort="false">
        <div class="widget-item" v-for="item in widgetList" :key="item.type">
          <a-icon :type="item.icon" class="widget-icon" />
          <span>{{ item.label }}</span>
        </div>
      </draggable>
    </div>

    <div class="cms-work-area" @click.self="clearSelection">
      <div class="area-header">
        <a-button icon="arrow-left" @click="$emit('back')" style="margin-right:20px">返回列表</a-button>
        <span>正在装修: {{ productInfo.name }}</span>
        <div style="flex:1"></div>
        <a-button type="primary" icon="save" @click="handleSaveWholePage">保存设计</a-button>
      </div>

      <div class="canvas-outer-wrapper" @click.self="clearSelection">
        <div class="canvas-wrapper" :style="canvasStyle">
          <draggable v-model="rows" :group="{ name: 'row_root', put: ['widgets', 'row_root'] }" animation="300"
            handle=".row-drag-handle" class="canvas-list" @change="onRowChange">
            <div v-for="(row, rowIndex) in rows" :key="row.tempId" class="cms-row">
              <div class="row-handle-group">
                <a-icon type="drag" class="row-drag-handle" />
                <a-icon type="delete" class="row-delete-btn" @click="deleteRow(rowIndex)" />
              </div>
              <draggable v-if="row.children" v-model="row.children" group="widgets" animation="300"
                class="row-flex-container">
                <div v-for="(element, colIndex) in row.children" :key="colIndex" class="cms-component-wrapper"
                  :class="{ 'is-selected': selectedId === element.tempId }" @click.stop="handleSelect(element)">
                  <div class="preview-media-box">
                    <div class="gray-placeholder">
                      <div class="type-tag">{{ element.label }}</div>
                      <div style="padding:20px">{{ element.contentData.title || '无标题' }}</div>
                    </div>
                  </div>
                  <div class="selected-mask" v-if="selectedId === element.tempId"></div>
                </div>
              </draggable>
            </div>
          </draggable>
        </div>
      </div>
    </div>

    <div class="cms-properties">
      <template v-if="selectedItem">
        <div class="prop-header">编辑属性</div>
        <a-form-model layout="vertical">
          <a-form-model-item label="标题">
            <a-input v-model="selectedItem.contentData.title" />
          </a-form-model-item>
        </a-form-model>
      </template>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import { getProduct, saveProduct } from '@/api'

  export default {
    name: 'ProductEditor',
    components: { draggable },
    // 【关键修改】接收 productId 参数
    props: {
      productId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        productInfo: {},
        rows: [],
        widgetList: [
          { type: 'title', label: '标题', icon: 'font-size' },
          { type: 'image', label: '图片', icon: 'picture' },
          { type: 'detail', label: '详情文本', icon: 'file-text' }
        ],
        selectedId: null,
        selectedItem: null,
        scaleRate: 1.0
      }
    },
    computed: {
      canvasStyle() { return { width: '375px', minHeight: '667px', transform: `scale(${this.scaleRate})` } }
    },
    created() {
      // 【关键修改】使用 props 加载数据
      if (this.productId) {
        this.loadData();
      }
    },
    methods: {
      loadData() {
        getProduct(this.productId).then(res => {
          this.productInfo = res.data;
          if (res.data.contentJson) {
            try {
              this.rows = JSON.parse(res.data.contentJson);
            } catch (e) {
              this.rows = [];
            }
          }
        });
      },
      handleSaveWholePage() {
        const dataToSave = {
          id: this.productId,
          editToken: this.productInfo.editToken,
          contentJson: JSON.stringify(this.rows)
        };
        saveProduct(dataToSave).then(res => {
          this.productInfo = res.data;
          this.$message.success("保存成功");
          // 保存后不强制返回，让用户决定是否继续编辑
        });
      },
      // ... cloneWidget, onRowChange, handleSelect, clearSelection, deleteRow 等方法保持不变 ...
      cloneWidget(origin) {
        return {
          type: origin.type,
          label: origin.label,
          tempId: Math.random().toString(36).substr(2),
          children: [],
          contentData: { title: '新组件' }
        }
      },
      onRowChange(evt) {
        if (evt.added) {
          const widget = evt.added.element;
          const newRow = { type: 'layout_row', tempId: Math.random().toString(36).substr(2), children: [widget] };
          this.$set(this.rows, evt.added.newIndex, newRow);
        }
      },
      handleSelect(item) {
        this.selectedId = item.tempId;
        this.selectedItem = item;
      },
      clearSelection() {
        this.selectedId = null;
        this.selectedItem = null;
      },
      deleteRow(index) {
        this.rows.splice(index, 1);
      }
    }
  }
</script>

<style scoped>
  /* 保持原有样式，略 */
  .cms-container {
    display: flex;
    background: #f5f7fa;
    border: 1px solid #eee;
  }

  .cms-sidebar {
    width: 220px;
    background: #fff;
    padding: 15px;
    border-right: 1px solid #eee;
  }

  .cms-work-area {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .area-header {
    height: 50px;
    background: #fff;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .canvas-outer-wrapper {
    flex: 1;
    background: #f0f2f5;
    display: flex;
    justify-content: center;
    padding: 20px 0;
    overflow-y: auto;
  }

  .canvas-wrapper {
    background: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    min-height: 600px;
  }

  .cms-properties {
    width: 300px;
    background: #fff;
    border-left: 1px solid #eee;
    padding: 20px;
  }

  .widget-item {
    padding: 10px;
    border: 1px solid #eee;
    margin-bottom: 10px;
    cursor: move;
    background: #fff;
  }

  .cms-row {
    position: relative;
    border: 1px dashed transparent;
    min-height: 50px;
  }

  .cms-row:hover {
    border-color: #1890ff;
  }

  .row-handle-group {
    position: absolute;
    right: -30px;
    top: 0;
    display: none;
  }

  .cms-row:hover .row-handle-group {
    display: block;
  }

  .cms-component-wrapper {
    padding: 5px;
    border: 2px solid transparent;
  }

  .cms-component-wrapper.is-selected {
    border-color: #1890ff;
  }
</style>
